import React, { useState, useEffect, useContext } from "react";
import { UserContext, getCurrentToken } from "./context/UserContext";
import { useNavigate } from "react-router-dom";
import requests from "./base";
import {
  BarChart,
  LineChart,
  Line,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
} from "recharts";


const Admindashboard = () => {
  const { signOut } = useContext(UserContext);
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [productCount, setUsersCount] = useState(0);
  const [unapprovedCount, setUnapprovedCount] = useState(0);
  const [UnapprovedProductsCount, setUnapprovedProductsCount] = useState([]);
  const [UnapprovedServiceCount, setUnapprovedServiceCount] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [linechartData, setLineChartData] = useState([]);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    const checkToken = async () => {
      const token = getCurrentToken();
      if (!token) {
        navigate("/login");
      } else {
       
        await fetchUsers();
        setLoading(false);

        await fetchUsers();
        
        const count = await fetchUsersCount();
        setUsersCount(count);
        const counts = await fetchUnapprovedCount()
        setUnapprovedCount(counts);
        const UnapprovedProductCount = await fetchUnapprovedProductCount();
        setUnapprovedProductsCount(UnapprovedProductCount);
         const UnapprovedServiceCount = await fetchUnapprovedServicesCount();
        setUnapprovedServiceCount(UnapprovedServiceCount);
         
      }
    };
    checkToken();
  }, [navigate]);

  




  // Fetch products from backend API
  const fetchUsers = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorproductsbyvendorID?VendorID=${vendorID}`
      );
      if (response?.Data) {
        setProducts(response.Data);
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
    }
  };



  // counting Start

  const fetchUsersCount = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getallVendors`
      );
      if (response?.Data) {
        return response.Data.length; // Return total number of items
      } else {
        return 0; // If no data returned
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
      return 0; // Return 0 on error
    }
  };

 const fetchUnapprovedCount = async () => {
  try {
    const token = getCurrentToken();
    const vendorID = token.Data.UserId;

    const response = await requests.get(`/getallVendors`);

    if (response?.Data) {
      // Filter unapproved vendors
      const unapproved = response.Data.filter(
        (vendor) => vendor.IsApproved === false
      );
      return unapproved.length;
    } else {
      return 0; // If no data returned
    }
  } catch (error) {
    console.error("Failed to fetch vendors:", error);
    return 0; // Return 0 on error
  }
};


  const fetchUnapprovedProductCount = async () => {
   try {
    const token = getCurrentToken();
    const vendorID = token.Data.UserId;

    const response = await requests.get(`/GetVendorProductsAndServices`);

    if (response?.Data) {
      // Filter unapproved vendors
      const unapprovedproducts = response.Data.filter(
        (product) => product.Type === "Product"
      );
      return unapprovedproducts.length;
    } else {
      return 0; // If no data returned
    }
  } catch (error) {
    console.error("Failed to fetch vendors:", error);
    return 0; // Return 0 on error
  }
  };

  const fetchUnapprovedServicesCount = async () => {
    try {
    const token = getCurrentToken();
    const vendorID = token.Data.UserId;

    const response = await requests.get(`/GetVendorProductsAndServices`);

    if (response?.Data) {
      // Filter unapproved vendors
      const unapprovedproducts = response.Data.filter(
        (product) => product.Type === "Service"
      );
      return unapprovedproducts.length;
    } else {
      return 0; // If no data returned
    }
  } catch (error) {
    console.error("Failed to fetch vendors:", error);
    return 0; // Return 0 on error
  }
  };
  
  useEffect(() => {
    const checkTokenAndFetch = async () => {
      const token = getCurrentToken();
      if (!token) {
        navigate("/login");
        return;
      }

      await fetchVendors();
      setLoading(false);

         await fetchVendorsadmins();
      setLoading(false);
    };
    

    checkTokenAndFetch();
  }, [navigate]);

  const fetchVendors = async () => {
    try {
      const response = await requests.get("/getallVendors");
      if (response?.Data) {
        const vendors = response.Data;

        // Count vendors by month/year
        const grouped = {};
        vendors.forEach((vendor) => {
          const date = new Date(vendor.CreatedDate);
          const monthYear = date.toLocaleString("default", {
            month: "short", // e.g., "Jun"
            year: "numeric", // e.g., "2025"
          });

          grouped[monthYear] = (grouped[monthYear] || 0) + 1;
        });

        // Convert to chart array format
        const chartArray = Object.entries(grouped).map(([month, count]) => ({
          month,
          count,
        }));

        // Sort chronologically
        chartArray.sort((a, b) => {
          const aDate = new Date(`${a.month} 1`);
          const bDate = new Date(`${b.month} 1`);
          return aDate - bDate;
        });

        setChartData(chartArray);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };



  const fetchVendorsadmins = async () => {
  try {
    const response = await requests.get("/getallVendors");
    if (response?.Data) {
      const vendors = response.Data;

      // Count vendors by AdminBoundary1 value
      const groupedBoundaries = {};
      vendors.forEach((vendor) => {
        // Use the raw AdminBoundary1 value as key (convert to string to be safe)
        const boundary = vendor.AdminBoundary2 !== undefined ? vendor.AdminBoundary2.toString() : "Unknown";

        groupedBoundaries[boundary] = (groupedBoundaries[boundary] || 0) + 1;
      });

      // Convert to chart array format: [{ boundary: '1', count: 10 }, ...]
      const chartArray = Object.entries(groupedBoundaries).map(([boundary, count]) => ({
        boundary,
        count,
      }));

      // Optional: sort by boundary if numeric (ascending)
      chartArray.sort((a, b) => {
        const aNum = Number(a.boundary);
        const bNum = Number(b.boundary);

        // If both are numbers, sort numerically, else keep original order
        if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;
        return 0;
      });

      setLineChartData(chartArray);
    }
  } catch (error) {
    console.error("Error fetching vendors:", error);
  }
};
  

 
  return (
    <>
      <div className="container mt-4 me-4">
        <div className="row">
          <div
            className="card d-flex flex-row align-items-center p-3 border-0"
            style={{ height: "70px", width: "100%" }}
          >
            <div className="flex-grow-1">
              <h3 className="mb-0 fw-bold">
                Admin Dashboard
              </h3>
            </div>
            <img
              src="../acre-africa-logo.svg"
              alt="User"
              className="rounded-circle"
              style={{ width: "40px", height: "40px", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>

      <div className="container mt-4">
        {/* Row of 4 cards */}
        <div className="row">
          {/* Card 1 */}

          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body">
                <p className="card-text fw-bold">Total Vendors</p>
                <h1 className="card-title fw-bolder text-info">{productCount}</h1>
                <span className="card-text smaller-text text-secondary">
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body ">
                <p className="card-text fw-bold">Unapproved Vendors</p>
                <h1 className="card-title fw-bolder text-danger">{unapprovedCount}</h1>
                <span className="card-text smaller-text">
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body">
                <p className="card-text fw-bold">Unapproved Products </p>
                <h1 className="card-title fw-bolder text-primary">{UnapprovedProductsCount}</h1>
                <span className="card-text smaller-text text-success">
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body">
                <p className="card-text fw-bold">Unapproved Services</p>
                <h1
                  className="card-title fw-bolder"
                  style={{ color: "#f5821f" }}
                >
                  {UnapprovedServiceCount}
                </h1>
                <span
                  className="card-text smaller-text "
                  style={{ color: "#f5821f" }}
                >
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Orders table and Status card below */}
        
      </div>
   <div className="row mt-3">
  {/* Bar Chart - Vendor Registration Trend */}
  <div className="col-md-6 mb-3">
    <div className="bg-white text-center p-3 rounded shadow-sm">
      <h3>Vendor Registration Trend</h3>
      {loading ? (
        <p>Loading chart...</p>
      ) : (
        <ResponsiveContainer height={400}>
          <BarChart data={chartData} margin={{ top: 10, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={false} />
            <XAxis dataKey="month" axisLine={false} tickLine={false} />
            <YAxis allowDecimals={false} axisLine={false} tickLine={false} />
            <Tooltip />
            <Bar
              dataKey="count"
              fill="#87CEFA"
              name="Vendors Registered"
              radius={[10, 10, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  </div>

  {/* Line Chart - AdminBoundary1 Trend */}
  <div className="col-md-6 mb-3">
    <div className="bg-white text-center p-3 rounded shadow-sm">
      <h3>User Distribution by AdminBoundary1</h3>
      <ResponsiveContainer height={400}>
  <LineChart data={linechartData}>
    <XAxis dataKey="boundary" axisLine={false} tickLine={false} />
    <YAxis allowDecimals={false} axisLine={false} tickLine={false} />
    <Tooltip />
    <defs>
      <linearGradient id="solidColorFill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#87CEFA" stopOpacity={1} />
        <stop offset="100%" stopColor="#87CEFA" stopOpacity={1} />
      </linearGradient>
    </defs>
    <Area
      type="monotone"
      dataKey="count"
      stroke="#87CEFA"
      fill="url(#solidColorFill)"
      fillOpacity={1}
    />
    <Line
      type="monotone"
      dataKey="count"
      stroke="#87CEFA"
      strokeWidth={3}
      dot={{ r: 5 }}
      activeDot={{ r: 7 }}
    />
  </LineChart>
</ResponsiveContainer>

    </div>
  </div>
</div>


    </>
  );
};

export default Admindashboard;
